<template>
  <Transition name="fade">
    <div 
      v-if="show"
      class="loading-overlay fixed inset-0 flex items-center justify-center z-[9999] bg-white/50"
    >
      <div class="!h-16 !w-16 i-carbon-progress-bar-round animate-spin c-secondary-500" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

defineOptions({
  name: 'LoadingOverlay'
})
</script>

<style scoped>
.loading-overlay {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style> 